export default __webpack_public_path__ + "static/media/icon-alert.220b879b.svg";